import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperSelectTeamPage } from './shopper-select-team';

@NgModule({
  declarations: [
    ShopperSelectTeamPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperSelectTeamPage),
    TranslateModule.forChild()
  ],
})
export class ShopperSelectTeamPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-select-team/shopper-select-team.module.ts